<template>
  <div>
    <form-header name="新建手术转运派单"></form-header>

    <Form
      ref="form"
      :model="forms"
      :label-width="150"
      :disabled="action == 'view' ? true : false"
    >
      <div class="third-line">
        <div>
          <p><span style="color: red">*</span> 病人信息:</p>
          <Select
            class="SelectDesk"
            v-model="patientId"
            filterable
            placeholder="请选择病人信息"
            clearable="true"
          >
            <Option v-for="item in patientList" :value="item.id" :key="item.id"
              >{{ item.patientName }}
            </Option>
          </Select>
        </div>
      </div>
      <div class="third-line">
        <div>
          <p><span style="color: red">*</span> 患者所在科室:</p>
          <Select
            class="SelectDesk"
            v-model="deskId"
            filterable
            placeholder="请选择或搜索科室"
            clearable="true"
          >
            <Option v-for="item in transportList" :value="item.id" :key="item.id"
              >{{ item.deskName }}
            </Option>
          </Select>
        </div>
      </div>
      <div class="third-line">
        <div>
          <p><span style="color: red">*</span> 护送到手术间:</p>
          <Select
            class="SelectDesk"
            v-model="transferDeskId"
            filterable
            placeholder="请选择或搜索科室"
            clearable="true"
          >
            <Option v-for="item in operationRoonmList" :value="item.id" :key="item.id"
              >{{ item.deskName }}
            </Option>
          </Select>
        </div>
      </div>

      <div class="third-line">
        <div>
          <RadioGroup
            v-model="sendTypePatient"
            @on-change="changeOrderTypePatient(sendTypePatient)"
            class="RadioGroup"
          >
            <Radio :label="2">自动派单</Radio>
            <!-- <Radio :label="3">抢单派单</Radio> -->
            <Radio :label="1">手动派单</Radio>
          </RadioGroup>
          <Select
            class="leftSelect"
            v-model="engineerPatient"
            placeholder="请选择护工"
            clearable="true"
            v-show="singlePatient == false ? true : false"
            @on-change="SelectengineerPatient(engineerPatient)"
          >
            <Option v-for="item in engineerListPatient" :value="item.name" :key="item.id"
              >{{ item.name }}
            </Option>
          </Select>
        </div>
      </div>
      <div class="workleft-2">
        <Button type="info" @click="newWorkPatient" size="default" class="button2"
          >保 存
        </Button>
      </div>
    </Form>
  </div>
</template>
<script>
import baseEdit from "@/views/components/base/baseEdit.vue";

export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "nursing",
      teackRemark: "",
      patientId: "",
      patientList: {},
      transportList: {},
      operationRoonmList: {},
      key: "id",
      //手术转运
      //派单类型
      sendTypePatient: 1,
      //展示护工
      singlePatient: true,
      //起点科室
      deskId: "",
      //目标科室
      transferDeskId: "",
      nursingId: "",
      //病人姓名
      patientName: "",
      //护工id
      engineerPatient: "",
      //护工列表
      engineerListPatient: {},
    };
  },
  computed: {},
  mounted() {},
  async created() {
    let query = this.$route.query;
    if (query.kv) {
      this.patientId = query.kv;
    }
    this.changeOrderTypePatient(this.sendTypePatient);
    await this.changePatient();
    await this.deskListTransport();
    await this.getOperationRoonmList();
    await this.patientListMethod();
  },
  methods: {
    changeOrderTypePatient(item) {
      if (item == 1) {
        this.singlePatient = false;
      } else {
        this.singlePatient = true;
      }
    },

    SelectengineerPatient(item) {
      if (this.engineerListPatient.length > 0) {
        for (let i = 0; i < this.engineerListPatient.length; i++) {
          let a = this.engineerListPatient[i];
          if (a.name == item) {
            this.nursingId = a.id;
          }
        }
      }
    },

    async deskListTransport() {
      let res = await $utils.api.load(
        "/admin/system/desk/selectListByNursing",
        {},
        "get"
      );
      this.transportList = res.rows;
      for (let i = 0; i < this.transportList.length; i++) {
        let workInfotemp = "";
        if (
          this.transportList[i].deskName !== null &&
          this.transportList[i].deskName !== undefined
        ) {
          workInfotemp = this.transportList[i].deskName;
        }
        if (
          this.transportList[i].principal !== null &&
          this.transportList[i].principal !== undefined
        ) {
          workInfotemp = workInfotemp + "/" + this.transportList[i].principal;
        }
        if (
          this.transportList[i].phone !== null &&
          this.transportList[i].phone !== undefined
        ) {
          workInfotemp = workInfotemp + "/" + this.transportList[i].phone;
        }
        if (
          this.transportList[i].address !== null &&
          this.transportList[i].address !== ""
        ) {
          workInfotemp = workInfotemp + "/" + this.transportList[i].address;
        }
        this.transportList[i].deskName = workInfotemp;
      }
    },
    async getOperationRoonmList() {
      let res = await $utils.api.load(
        "/admin/system/desk/selectListByNursingByOperationRoonm",
        {},
        "get"
      );
      this.operationRoonmList = res.rows;
      for (let i = 0; i < this.operationRoonmList.length; i++) {
        let workInfotemp = "";
        if (
          this.operationRoonmList[i].deskName !== null &&
          this.operationRoonmList[i].deskName !== undefined
        ) {
          workInfotemp = this.operationRoonmList[i].deskName;
        }
        if (
          this.operationRoonmList[i].principal !== null &&
          this.operationRoonmList[i].principal !== undefined
        ) {
          workInfotemp = workInfotemp + "/" + this.operationRoonmList[i].principal;
        }
        if (
          this.operationRoonmList[i].phone !== null &&
          this.operationRoonmList[i].phone !== undefined
        ) {
          workInfotemp = workInfotemp + "/" + this.operationRoonmList[i].phone;
        }
        if (
          this.operationRoonmList[i].address !== null &&
          this.operationRoonmList[i].address !== ""
        ) {
          workInfotemp = workInfotemp + "/" + this.operationRoonmList[i].address;
        }
        this.operationRoonmList[i].deskName = workInfotemp;
      }
    },
    async patientListMethod() {
      let type = 1;
      let res = await $utils.api.load(
        `/admin/system/nursing/patientList/${type}`,
        {},
        "get"
      );
      if (res && res.rows) {
        this.patientList = res.rows;
        for (let i = 0; i < this.patientList.length; i++) {
          let workInfotemp = "";
          if (
            this.patientList[i].patientName !== null &&
            this.patientList[i].patientName !== undefined
          ) {
            workInfotemp = this.patientList[i].patientName;
          }
          if (
            this.patientList[i].patientId !== null &&
            this.patientList[i].patientId !== undefined
          ) {
            workInfotemp = workInfotemp + "/" + this.patientList[i].patientId;
          }
          this.patientList[i].patientName = workInfotemp;
        }
      }
    },

    //查询维修员
    changePatient() {
      let q = {};
      // 通过pk查询字典数据
      $utils.api.load("/admin/system/user/nursinglist", q, "get").then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let arr = [];
          if (ll.length > 0) {
            for (let i = 0; i < ll.length; i++) {
              let item = ll[i];
              let obj = {
                name: item.nickName,
                id: item.userId,
              };
              arr.push(obj);
            }
            this.engineerListPatient = arr;
          }
        }
      });
    },
    async newWorkPatient() {
      let q = {};
      if (this.deskId == "") {
        return $utils.toast.error("患者所在科室不可为空");
      }
      if (this.transferDeskId == "") {
        return $utils.toast.error("护送到手术间不可为空");
      }
      if (this.sendTypePatient == 1) {
        if (this.nursingId) {
          q.nursingId = this.nursingId;
        } else {
          return $utils.toast.error("手动派单护工不可为空");
        }
      }
      q.deskId = this.deskId;
      q.transferDeskId = this.transferDeskId;
      q.id = this.patientId;
      q.transferContent = this.transferContent;
      q.sendType = this.sendTypePatient;
      let res = await $utils.api.load("/admin/system/nursing/addNursing", q, "post");
      if (res.code == 200) {
        if (res.status) {
          $utils.toast.success("保存成功");
          setTimeout(() => {
            $utils.url.go(-1);
          }, 1000);
        }
      } else {
        $utils.toast.error("保存失败");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.third-line {
  width: 600px;
  margin-bottom: 20px;
  div {
    display: flex;
    justify-content: flex-start;
    width: 100%;

    .SelectDesk {
      width: 60%;
      display: inline-block;
    }

    p {
      color: #00050e;
      font-size: 0.875rem;
      padding-top: 5px;
      text-align: left;
      width: 19%;
      display: inline-block;
      margin-right: 5px;
    }
    .RadioGroup {
      width: 45%;
      margin-top: 5px;
      margin-bottom: 20px;
    }
    .leftSelect {
      display: inline-block;
      width: 35%;
    }
  }
}
</style>
